import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { Button, PopUpTitles } from '../../../../../shared/model/enum';
import { AgGridI, PaginationBaseModel, TableSouringPaginationModel } from '../../../../../shared/components/ag-grid/ag-grid.model';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { StorageService } from '../../../../../shared/services/storage.service';
import { GridName } from '../../../../crm/crm.model';
import { AgGridDataModelSTSRequirement, AgGridDataModelSTSSourcing } from '../../../../procurement/sourcing/pages/sourcing/sourcing.model';
import { CommonService } from '../../../../../shared/services/common.service';
import { AgGridService } from '../../../../../shared/components/ag-grid/ag-grid.service';
import { AgGridComponent } from '../../../../../shared/components/ag-grid/ag-grid.component';
import { InsertSourcing } from './send-to-sourcing.model';
import { SourcingService } from '../../../../procurement/sourcing/pages/sourcing/sourcing.service';
import { ToastrService } from 'ngx-toastr';
import { StorageName } from '../../../../../shared/model/ag-grid-common-constant';

@Component({
  selector: 'app-send-to-sourcing-popup',
  templateUrl: './send-to-sourcing-popup.component.html',
  styleUrls: ['./send-to-sourcing-popup.component.scss']
})
export class SendToSourcingPopupComponent implements OnInit {
  @ViewChildren(AgGridComponent) grids!: QueryList<AgGridComponent>
  @ViewChildren('sourcingGrid') sourcingGrids!: QueryList<AgGridComponent>
  data: any;
  enumButtonName = Button;
  enumPopUpTitles = PopUpTitles;
  agGridDataModelRequirement!: AgGridI;
  agGridDataModelSourcing!: AgGridI;
  gridApiForRequirementList: any;
  gridApiForSourcingList: any;
  tablePaginationModelRequirement = new PaginationBaseModel();
  tablePaginationModel = new TableSouringPaginationModel();
  insertSourcing = new InsertSourcing()
  flexHeight: string = "";
  selectedReqData : any[]=[]
  selectedSourcingData : any[]=[]
  rowDataLength: number = 0;
  constructor(
    public activeModal: NgbActiveModal,
    public storageService: StorageService,
    public commonService: CommonService,
    public agGridService: AgGridService,
    public service: SourcingService,
    public toaster: ToastrService,
  ) {}

  ngOnInit(): void {
    this.agGridDataModelRequirement = AgGridDataModelSTSRequirement;
    this.agGridDataModelSourcing = AgGridDataModelSTSSourcing;
    this.getRequirementList();

    this.commonService.headerHeight.subscribe((res) => {
      if(window.innerWidth < 1200){
        this.flexHeight = `calc(100vh - 642px - ${res}px)`;
      }else{
        this.flexHeight = `calc(100vh - 729px - ${res}px)`;
      }
    });
  }
  onReqPagination(pagination: PaginationBaseModel) {
    this.storeReqChangedPagination(pagination);
    this.getRequirementList();
  }
  storeReqChangedPagination(paginationModel: PaginationBaseModel) {
    this.tablePaginationModelRequirement = paginationModel;
  }
  onReqGridReady(event: any) {
    this.gridApiForRequirementList = event;
    this.tablePaginationModelRequirement = this.storageService.retrieve(
      GridName.AG_GRID_STS_REQUIREMENT_PAGINATIONMODEL
    );
    if (this.tablePaginationModelRequirement) this.getRequirementList();
  }
  onReqSelectionChange(params) {
    this.selectedReqData = params?.api?.getSelectedRows();
  }
  onSourcingSelectionChange(params) {
    this.selectedSourcingData = params?.api?.getSelectedRows();
  }
  onSourcingPagination(pagination: TableSouringPaginationModel) {
    this.storeSourcingChangedPagination(pagination);
    this.getSourcingList();
  }
  storeSourcingChangedPagination(paginationModel: TableSouringPaginationModel) {
    this.tablePaginationModel = paginationModel;
  }
  onSourcingGridReady(event: any) {
    this.gridApiForSourcingList = event;
    this.tablePaginationModel = this.storageService.retrieve(
      GridName.AG_GRID_STS_SOURCING_PAGINATIONMODEL
    );
    if (this.tablePaginationModel) this.getRequirementList();
  }
  getRequirementList() {
      this.gridApiForRequirementList?.api?.setRowData(this.data ?? []);
  }
  buildRequest() {
    return {
      searchText: this.tablePaginationModel?.searchText ?? "",
      sortColumn: this.tablePaginationModel?.sortColumn ?? "",
      sortDirection: this.tablePaginationModel?.sortDirection ?? "",
      pageNumber: this.tablePaginationModel?.pageNumber ?? 1,
      pageSize: this.tablePaginationModel?.pageSize ?? 25,
      getAll: this.tablePaginationModel?.getAll ?? false,
      dateRange: this.tablePaginationModel?.dateRange ?? "",
      statusId: this.tablePaginationModel?.statusId ?? "",
      stage: this.tablePaginationModel?.stage ?? "",
    };
  }

  getSourcingList() {
    // let list: any = [{ id: '1261', sbNo: '1261', status: 'Open', salesperson: 'John Doe', dateCreated: '07/03/2025', partNo: 10, readyToQuote: 10, noBid: 5, },
    //   { id: '1262', sbNo: '1262', status: 'Open', salesperson: 'John Doe', dateCreated: '07/03/2025', partNo: 10, readyToQuote: 10, noBid: 5, }
    // ]
    // this.rowDataLength = list.length;
    // this.gridApiForSourcingList?.api?.setRowData(list);
    // return

    if (this.sourcingGrids?.first) {
      this.sourcingGrids.first.agGridPaginationConfig.rows = []
      this.sourcingGrids.first.isLoading = true;
      let data = this.buildRequest();
      this.agGridService.getAllSourcingData(data).subscribe({
        next: (res) => {
          if (res?.isSuccess) {
            this.sourcingGrids.first.isLoading = false;
            this.gridApiForSourcingList?.api?.setRowData(res?.response ?? []);
            if (!res?.response?.length) { this.sourcingGrids.first.agGridPaginationConfig.rows = [] }
            let sourcingData = res?.response ?? [];
            this.storageService.store(StorageName.PROCUREMENT_SOURCING, sourcingData);
            this.sourcingGrids.first.updatePaginationData(this.tablePaginationModel, res.totalRecords);
            // Removed global selectionChanged.next to prevent hijacking background header buttons
          } else {
            this.sourcingGrids.first.isLoading = false;
            this.sourcingGrids.first.agGridPaginationConfig.rows = []
            this.gridApiForSourcingList?.api?.setRowData([]);
          }
        },
        error: (err) => {
          this.sourcingGrids.first.isLoading = false;
          this.sourcingGrids.first.agGridPaginationConfig.rows = []
          this.gridApiForSourcingList?.api?.setRowData([]);
        }
      })
    }
  }
  get canCreateOrAddToBatch(): boolean {
    return this.selectedSourcingData?.length === 1;
  }

  createSourcingBatch(action: string) {
    if (action == 'ADD_TO_SOURCING_BATCH' && !this.canCreateOrAddToBatch) return
    this.insertSourcing.requirementIds = this.data.map((x) => x.id);
    this.insertSourcing.salesPersonId = this.data?.find(item => item?.salesPersonId)?.salesPersonId || "";
    if (action == 'ADD_TO_SOURCING_BATCH') {
      this.insertSourcing.sourcingBatchId = this.selectedSourcingData?.[0]?.id
    }else{
      this.insertSourcing.sourcingBatchId = '';
    }
    this.service.addSourcing(this.insertSourcing).subscribe({
      next: (res: any) => {
        if (res.isSuccess == true) {
          this.toaster.success(res.message);
          this.activeModal.close({res,confirm:true});
        }
        else {
          this.toaster.error('');
        }
      },
      error: (error:any) => {
        console.log("error",error);
      }
    }
    )
  }

  ngOnDestroy(): void { }

}
